import { KeyRound, FileCheck2, BellRing, Users, ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/lib/Reveal";
import { BUSINESS } from "@/lib/data";

const PERKS = [
  { icon: FileCheck2, title: "CP12 from £75", text: "Official Gas Safety Certificate with same-day digital copy for your records." },
  { icon: BellRing, title: "Annual auto-reminders", text: "We track your expiry dates and book the renewal before it lapses — you're always compliant." },
  { icon: Users, title: "We deal with tenants", text: "Flexible access arranged directly with your tenants. Less admin, fewer phone calls for you." },
  { icon: KeyRound, title: "Priority breakdown cover", text: "Tenant without heating? Landlord jobs jump the queue with 24/7 emergency response." },
];

export const Landlords = ({ onBook }) => {
  return (
    <section id="landlords" data-testid="landlords-section" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Reveal><SectionLabel>09 / Landlords & letting agents</SectionLabel></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white mt-4">
                CP12s without<br />the chase.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-neutral-400 text-sm leading-relaxed">
              One property or a whole portfolio — gas safety compliance handled end to end,
              with reminders so a certificate never quietly expires on your watch.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          {PERKS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.08} className="h-full">
              <div className="h-full bg-surface border border-neutral-800 hover:border-torch rounded-sm p-6 transition-colors">
                <p.icon className="w-5 h-5 text-torch mb-4" />
                <h3 className="font-display font-bold text-white">{p.title}</h3>
                <p className="mt-2 text-sm text-neutral-400 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal>
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6 border border-neutral-800 rounded-sm p-7 bg-gradient-to-r from-surface to-[#171008]">
            <p className="text-neutral-300 text-sm sm:text-base">
              Boiler service + CP12 together? <span className="text-white font-semibold">Ask about landlord bundle pricing.</span>
            </p>
            <div className="flex flex-wrap gap-3 shrink-0">
              <button
                onClick={() => onBook("gas_safety")}
                data-testid="landlords-book-cp12-btn"
                className="group bg-torch hover:bg-torch-hover text-white font-display font-bold uppercase tracking-wide px-6 py-3.5 rounded-sm flex items-center gap-2.5 transition-all hover:shadow-[0_0_28px_rgba(255,85,0,0.45)]"
              >
                Book a CP12 — £75
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </button>
              <a
                href={BUSINESS.whatsapp}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="landlords-whatsapp-btn"
                className="border border-neutral-700 hover:border-torch text-neutral-200 hover:text-torch font-display font-bold uppercase tracking-wide px-6 py-3.5 rounded-sm transition-colors"
              >
                Portfolio quote
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
